export enum IconPlace {
  Right = 'right',
  Left = 'left',
}

export enum Size {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum Variant {
  Default = 'default',
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
  Succeeded = 'succeeded',
}
